/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DarkInputs */



/**
* | output |
* | --- |
* | "Dark" |
*
* @param {DarkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dark = /** @type {((inputs?: DarkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DarkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dunkel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Buio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Темный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Oscuro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("黑暗的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("暗い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अँधेरा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escuro")
	return /** @type {LocalizedString} */ ("Dark")
});